export const getEndCustomerData = ({ endCustomer }: any) => endCustomer;
